import { render, staticRenderFns } from "./ClientIncomePopUp.vue?vue&type=template&id=c0ef5ef2&scoped=true&"
import script from "./ClientIncomePopUp.vue?vue&type=script&lang=js&"
export * from "./ClientIncomePopUp.vue?vue&type=script&lang=js&"
import style0 from "./ClientIncomePopUp.vue?vue&type=style&index=0&id=c0ef5ef2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../bankari hypo/BankariBroker/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0ef5ef2",
  null
  
)

export default component.exports